import classNames from 'classnames'
import React from 'react'

import { Body2 } from '@ui/Typography'
import { RichIcon } from '@ui/components/RichIcon'
import { CheckIcon } from '@ui/icons/Check.icon'
import { WarningIcon } from '@ui/icons/Warning.icon'

import { Box } from '@shared/components/Box'

import styles from './StepCircle.module.scss'

export interface StepCircleProps {
  isActive: boolean
  section: number
  isRed?: boolean
  isSmall?: boolean
  isCompleted?: boolean
  isFailed?: boolean
  subStep?: {
    current: number
    total: number
  }
  isHidden?: boolean
}

export const StepCircle: React.FC<StepCircleProps> = ({
  section,
  isActive,
  isRed,
  isSmall,
  isCompleted,
  isFailed,
  subStep,
  isHidden,
}) => {
  const hiddenStepSection = 3

  if (isFailed) {
    return (
      <Box mr='x8'>
        <RichIcon
          size='x32'
          icon={{ icon: WarningIcon, color: 'text-danger-high-em' }}
          border='outline-danger-high-em'
          shape='circle'
        />
      </Box>
    )
  }

  if (isCompleted) {
    return (
      <Box mr='x8'>
        <RichIcon
          size='x32'
          icon={{ icon: CheckIcon, color: 'text-success-high-em' }}
          border='outline-secondary-high-em'
          shape='circle'
        />
      </Box>
    )
  }

  const showSubStep = isActive && !!subStep?.current && !(section === hiddenStepSection && isHidden)

  return (
    <Body2
      className={classNames(styles.numberCircle, {
        [styles.isActive]: isActive,
        [styles.isRed]: isRed,
        [styles.isSmall]: isSmall,
        [styles.extended]: showSubStep,
      })}
    >
      {section}
      {showSubStep && (
        <span className={styles.subStep}>
          {subStep.current}/{subStep.total}
        </span>
      )}
    </Body2>
  )
}
